import React from "react";

export const checkApprover = (itemInEdit, setItemInEdit, setInitialApprover, setIsApproverExists, validationObj, setValidationObj, user, api, apiUrl, setLoading, lodashFunc) => {
    const approverErrorCheck = (data) => {
        const checkResult = data !== null && (data?.approver || data?.autoApproved);
        setIsApproverExists(checkResult);
            // console.log(data);
        const errors = [...validationObj];
        const itemType = `approver`;
        const exists = lodashFunc.some(errors, (item) => item.type === itemType);
        if (!checkResult && !exists)
            errors.push({ type: itemType, message: (
                <span>Incomplete approver list for the selected Project and Recruitment Type. Please contact HRIS Administrator to go to Maintenance {">"} Project to setup the approver list or click <u className="cursor-pointer" onClick={() => window.open(`/maintenance`, '_blank')}>here</u> if you have Administrator access.</span>
            ) });

        if (checkResult && exists)
            lodashFunc.remove(errors, (item) => item.type === itemType);

        setValidationObj([...errors]);

        if (checkResult)
        {
            setInitialApprover(data.autoApproved ? `${user.username} (auto approved)` : data.approver?.displayName);

            if (itemInEdit.approverName && (itemInEdit.status?.lookupValue.toLowerCase().includes("rejected") || itemInEdit.status?.lookupValue.toLowerCase().includes("declined")))
                setItemInEdit({...itemInEdit, approverName: null, autoApproved: data.autoApproved});

            if (!(itemInEdit.status?.lookupValue.toLowerCase().includes("rejected") || itemInEdit.status?.lookupValue.toLowerCase().includes("declined")))
                setItemInEdit({...itemInEdit, approverName: data.approver?.displayName, autoApproved: data.autoApproved});
        }
    };

    setInitialApprover(null);
    if (!itemInEdit?.projectId || !itemInEdit?.proposedRecruitmentTypeId)
    {
        setIsApproverExists(false);
        return;
    }
    setLoading(true);

    api.get(`${apiUrl}/approval/check?projectId=${itemInEdit.projectId}&recruitmentTypeId=${itemInEdit.proposedRecruitmentTypeId}&isSecondment=${itemInEdit?.secondmentProjectId ? true : false}&secondmentProjectId=${itemInEdit?.secondmentProjectId ?? 0}&isToolOfTrade=${itemInEdit?.isToolOfTrade ?? false}`)
        .then((response) => {
            const {data} = response;
            approverErrorCheck(data);
        })
        .catch((error) => console.error({error}))
        .finally(() => setLoading(false))
    ;
};

export const getDefaultSelectedAllocation = (itemInEdit, rows) => {
    const result = rows
        .filter((row) => {
            return row.projectId === itemInEdit?.projectId &&
                row.positionId === itemInEdit?.positionId &&
                row.endDate === itemInEdit?.currentEndDate;
            }
        )
        .reduce((acc, row) => {
            acc[row.candidateAllocationId] = true;
            return acc;
        }, {});
    return result;
};

export const validate = (itemInEdit, documents, readyForApproval = false) => {
    const validationResult = [];

    if (readyForApproval && !itemInEdit.approverName)
        validationResult.push({
            type: "error",
            message: "Approver is not found.",
        });

    if (!itemInEdit.candidateId)
        validationResult.push({
            type: "error",
            message: "Employee Name must be filled.",
        });

    if (!itemInEdit.proposedRecruitmentTypeId)
        validationResult.push({
            type: "error",
            message: "Proposed Requirement Type must be filled.",
        });

    if (!itemInEdit.proposedEmploymentTypeId)
        validationResult.push({
            type: "error",
            message: "Proposed Employment Basis must be filled.",
        });

    if ((itemInEdit.secondmentProjectId && (!itemInEdit.secondmentStartDate || !itemInEdit.secondmentEndDate)) || (!itemInEdit.secondmentProjectId && (itemInEdit.secondmentStartDate || itemInEdit.secondmentEndDate)))
        validationResult.push({
            type: "error",
            message: "Secondment: Project, Start Date and End Date must be filled.",
        });

    if (itemInEdit.eccAllowances?.filter(e => !e.allowanceTypeId || !e.allowance || !e.allowanceOccurenceId)?.length > 0)
        validationResult.push({
            type: "error",
            message: "Allowance: Type, Value and Occurence must be filled.",
        });

    if (itemInEdit.workSequenceObj?.lookupValue === "Other" && !itemInEdit.workSequence)
        validationResult.push({
            type: "error",
            message: "Roster: custom value must be filled.",
        });

    if (!itemInEdit.notes)
        validationResult.push({
            type: "error",
            message: "Justification must be filled.",
        });

    if (!documents?.length)
        validationResult.push({
            type: "error",
            message: "Please attach at least one supporting documentation.",
        });

    return validationResult;
};

export const validateApproval = (itemInEdit, approvalData, documents, readyForApproval = false) => {
    const validationResult = [];

    if (readyForApproval && !itemInEdit.approverName)
        validationResult.push({
            type: "error",
            message: "Approver is not found.",
        });

    if (!itemInEdit.candidateId)
        validationResult.push({
            type: "error",
            message: "Employee Name must be filled.",
        });

    if (!itemInEdit.proposedRecruitmentTypeId)
        validationResult.push({
            type: "error",
            message: "Proposed Requirement Type must be filled.",
        });

    if (!itemInEdit.proposedEmploymentTypeId)
        validationResult.push({
            type: "error",
            message: "Proposed Employment Basis must be filled.",
        });

    if ((itemInEdit.secondmentProjectId && !itemInEdit.secondmentEndDate) || (!itemInEdit.secondmentProjectId && itemInEdit.secondmentEndDate))
        validationResult.push({
            type: "error",
            message: "Secondment: Project and End Date must be filled.",
        });

    if (itemInEdit.eccAllowances?.filter(e => !e.allowanceTypeId || !e.allowance || !e.allowanceOccurenceId)?.length > 0)
        validationResult.push({
            type: "error",
            message: "Allowance: Type, Value and Occurence must be filled.",
        });

    if (itemInEdit.workSequenceObj?.lookupValue === "Other" && !itemInEdit.workSequence)
        validationResult.push({
            type: "error",
            message: "Roster: custom value must be filled.",
        });

    if (!itemInEdit.notes)
        validationResult.push({
            type: "error",
            message: "Justification must be filled.",
        });

    if ((approvalData.approverRole === "Managing Director" || approvalData.approverRole === "HR Director Team") && !documents?.length)
        validationResult.push({
            type: "error",
            message: "Related documentation is needed.",
        });

    return validationResult;
};

export const composeDataToSend = (id, itemInEdit, documents, isApproval = false, approved = false, reason = null) => {
    const formData = new FormData();

    for (let key in itemInEdit) {
        // console.log(key);
        if (key !== "eccAllowances" && key !== "eccApprovals" && key !== "eccDocuments") {
            if (typeof itemInEdit[key] === "object")
                continue;

            if (itemInEdit[key] !== undefined)
                formData.append(`${key}`, itemInEdit[key]);

            continue;
        }

        if (key === "eccAllowances") {
            itemInEdit.eccAllowances.forEach((d, idx) => {
                for (let dkey in d) {
                    if (typeof d[dkey] === "object")
                        continue;

                    if (dkey === "eccAllowanceId") {
                        formData.append(`${key}[${idx}].${dkey}`, d.eccAllowanceId);
                        continue;
                    }

                    if (d[dkey])
                        formData.append(`${key}[${idx}].${dkey}`, d[dkey]);
                }
            })
            continue;
        }
    }

    if (documents?.length) {
        const key = "eccDocuments";

        documents.forEach((d, idx) => {
            // console.log(d);
            formData.append(`${key}[${idx}].eccDocumentId`, d.eccDocumentId);
            formData.append(`${key}[${idx}].employeeChangeConditionId`, d.employeeChangeConditionId);

            if (d.file) {
                // console.log(d.file);
                formData.append(`${key}[${idx}].file`, d.file);
                formData.append(`${key}[${idx}].fileContentType`, "");
                formData.append(`${key}[${idx}].fileLength`, 0);
                formData.append(`${key}[${idx}].filename`, "");
                return;
            }

            // console.log(d.file);
            formData.append(`${key}[${idx}].fileContentType`, d.fileContentType);
            formData.append(`${key}[${idx}].fileLength`, d.fileLength);
            formData.append(`${key}[${idx}].filename`, d.filename);
        })
    }

    if (!isApproval)
        return formData;

    formData.append("eccApprovalId", id ?? 0);
    formData.append("statusValue", approved ? "Approved" : "Declined");

    if (!reason)
        return formData;

    formData.append("reason", reason);

    return formData;
};

export const returnToList = (history) => {
    history.push("/ecclist?mode=ecc");
};

export const returnToApprovalList = (history) => {
    history.push("/eccapprovallist?mode=ecc");
};